module.exports = __webpack_public_path__ + "static/media/medicine-pills-tablets-svgrepo-com.f1425ce0.svg";